<template>
  <div>
    <b-modal lazy ref="installPluginsAndThemesModal" size="lg custom-overlay installer-modal" :hide-footer="true" no-fade>
      <div slot="modal-header" class="w-100">
        <p class="float-left modal-title">Install Plugins / Themes</p>
        <b-btn size="sm" class="float-right" variant="flat" @click="closeModal">
          <close-icon class="icon-default close modalclose"></close-icon>
        </b-btn>
      </div>
      <b-row class="installation-container">
        <b-col cols="10" class="mx-auto h-100 flex-column">
          <site-selector :selected.sync="sites"></site-selector>
          <div class="installer-wrapper">
            <div class="custom-tab">
              <div class="custom-tab-body noheader hasfooter flex-column">
                <b-tabs>
                  <b-tab active>
                    <template slot="title">
                      <i class='img-icon plugin'></i>Plugins
                    </template>

                    <pluginthemeinstaller :sites="sites" type="plugins" @close="closeModal"></pluginthemeinstaller>
                  </b-tab>
                  <b-tab v-bind:title="`<i class='img-icon themes'></i>Themes`">
                    <template slot="title">
                      <i class='img-icon themes'></i>Themes
                    </template>
                    <pluginthemeinstaller :sites="sites" type="themes" @close="closeModal"></pluginthemeinstaller>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>

<script>
import SiteSelector from "../Common/SiteSelector";
import pluginthemeinstaller from "./pluginThemeInstaller";
import CloseIcon from "../../assets/close.svg";
export default {
  name: "installpluginsandthemes",
  components: { pluginthemeinstaller, SiteSelector, CloseIcon },
  data() {
    return {
      plugins: [],
      sites: [],
      selectedUpdatesCount: 0,
      selectAll: false,
      searchText: ""
    };
  },
  methods: {
    closeModal() {
      this.$refs.installPluginsAndThemesModal.hide();
    }
  }
};
</script>

<style scoped>
.installer-modal .custom-tab {
  padding: 0px 32px;
}
</style>
